import { useCallback, useEffect, useRef, useState } from "react";
const HOVER_LEAVE_DELAY_MS = 80;
export function useInteractionState({ isSelected = false, isContextMenuActive = false }) {
    const [isHovered, setIsHovered] = useState(false);
    const timeoutRef = useRef(undefined);
    const handleMouseEnter = useCallback(()=>{
        clearTimeout(timeoutRef.current);
        setIsHovered(true);
    }, []);
    const handleMouseLeave = useCallback(()=>{
        timeoutRef.current = setTimeout(()=>setIsHovered(false), HOVER_LEAVE_DELAY_MS);
    }, []);
    useEffect(function clearHoverTimeoutOnUnmount() {
        return ()=>clearTimeout(timeoutRef.current);
    }, []);
    return {
        isHovered,
        isActive: isSelected || isContextMenuActive,
        handleMouseEnter,
        handleMouseLeave
    };
}

//# sourceMappingURL=useInteractionState.js.map